module.exports = __webpack_public_path__ + "static/community-79be7c9a733a67889285d00030841ff8.svg";